import React, { useEffect, useMemo, useState } from "react"
import "react-date-range/dist/styles.css" // main css file
import "react-date-range/dist/theme/default.css" // theme css file
import { calculateTotal } from "../../Utility/utility.js"
import { isMobile } from "react-device-detect"
import {
  ErrorCard,
  LoadingCard,
  MainContainer,
  NextUITable,
} from "../../components"
import { apiRoute } from "../../constants/enum.js"
import { useSelector } from "react-redux"
import { useFetchWithBody, usePost } from "../../api/reactQueryCustomHooks.jsx"
import {
  COLUMN_ALIGN_TYPE,
  COLUMN_TYPE,
  FOOTER_TYPE,
} from "../../components/NextUITable.jsx"
import { faFilter, faMagnifyingGlass, } from "@fortawesome/free-solid-svg-icons"
import { Button, Autocomplete, AutocompleteItem } from "@nextui-org/react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

const Stock = () => {
  const { compCode, startDate, endDate } = useSelector((state) => state.company)
  const [selectedItem, setSelectedItem] = useState("")
      const [selectedGroup, setSelectedGroup] = useState("")
      const [selectedCategory, setSelectedCategory] = useState("")
  //{ key: "", value: "" })
  const [data, setData] = useState([])
  const [filterDate, setFilterDate] = useState({
    start: startDate ? startDate : null,
    end: endDate ? endDate : null
  })

  const { data: itemMasterData = [] } = useFetchWithBody({
    url: apiRoute.stock.fetchItemMaster,
    queryKey: "StockItemMaster",
  })

  const { data: masterData = [] } = useFetchWithBody({
    url: apiRoute.item.masterData,
    queryKey: "fetchMasterData"
  })

  
  const handleResetFilter = () => {
    setSelectedItem("")
    setSelectedGroup("")
    setSelectedCategory("")
    filterStock({
      data: {
        comp_code: compCode.join(","),
        item_code: null,
        item_cat: null,
        item_group:null,
        from_date: startDate ? new Date(startDate).toISOString().split("T")[0] : null,
        to_date: endDate ? new Date(endDate).toISOString().split("T")[0] : null,
        action: 'Detail'
      }
    })
  }


  const {
    data: stockData = [],
    isError,
    isPending,
    mutate: filterStock,
  } = usePost({
    url: apiRoute.stock.fetch,
    queryKey: "GetStock",

  })
  useEffect(() => {
    filterStock({
      data: {
        comp_code: compCode.join(","),
        item_code: null,
        item_cat: null,
        item_group:null,
        from_date: startDate ? new Date(startDate).toISOString().split("T")[0] : null,
        to_date: endDate ? new Date(endDate).toISOString().split("T")[0] : null,
        action: 'Detail'
      }
    })

  }, [])

  useEffect(() => {
    setData(stockData)
  }, [stockData])

  const handleDataChange = ({ data, isFilter }) => {
    if (isFilter)
      setData(data)
    else
      setData(stockData)
  }
  let totalQuantity = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "CLOSING",
      }),
    [data]
  )

  const handleFilter = () => {
    filterStock({
      data: {
        comp_code: compCode.join(","),
        item_code: selectedItem, //.key
        item_cat: selectedCategory,
        item_group: selectedGroup,
        from_date: filterDate.start ? new Date(filterDate.start).toISOString().split("T")[0] : null,
        to_date: filterDate.end ? new Date(filterDate.end).toISOString().split("T")[0] : null,
        action: 'Detail'
      }
    })
  }

  let downloadDataFooter = {
    ITEM_DESC: "",
    MADE: "",
    PACK_SIZE: "",
    L_Code: "",
    OURL_CODE: "",
    EXP_DATE: "",
    CLOSING: "Total: " + totalQuantity,
    RATE_Wo_Tax: "",
  }

  const exportColumns = [
    {
      uid: "ITEM_DESC",
      name: "Product Name",
    },
    {
      uid: "MADE",
      name: "Company",
    },
    {
      uid: "PACK_SIZE",
      name: "Pack Size",
    },
    {
      uid: "L_Code",
      name: "Lot No.",
    },
    {
      uid: "OURL_CODE",
      name: "Customer",
    },
    {
      uid: "EXP_DATE",
      name: "Expiry Date",
      type: COLUMN_TYPE.date,
    },
    {
      uid: "CLOSING",
      name: "Quantity",
    },
    {
      uid: "RATE_Wo_Tax",
      name: "Rate Wo Tax",
    },
  ]

  const INITIAL_VISIBLE_COLUMNS = [
    "ITEM_DESC",
    // "product_company",
    "MADE",
    "PACK_SIZE",
    "L_Code",
    "OURL_CODE",
    "EXP_DATE",
    "CLOSING",
    "RATE_Wo_Tax",
  ]

  const columns = [
    {
      uid: "ITEM_DESC",
      name: "Product Name",
      sortable: true,
    },
    {
      uid: "MADE",
      name: "Company",
      sortable: true,
    },
    {
      uid: "PACK_SIZE",
      name: "Pack Size",
      sortable: true,
    },
    {
      uid: "L_Code",
      name: "Lot No.",
      sortable: true,
    },
    {
      uid: "OURL_CODE",
      name: "Customer",
      sortable: true,
    },
    {
      uid: "EXP_DATE",
      name: "Expiry Date",
      type: COLUMN_TYPE.date,
      sortable: true,
    },
    {
      uid: "CLOSING",
      name: "Quantity",
      sortable: true,
      align: COLUMN_ALIGN_TYPE.center,
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total",
        value: totalQuantity,
      },
    },
    {
      uid: "RATE_Wo_Tax",
      name: "Rate Wo Tax",
      sortable: true,
      align: COLUMN_ALIGN_TYPE.center,
    },
  ]

  if (isPending) {
    return <LoadingCard />
  }

  if (isError) {
    return <ErrorCard />
  }

  return (
    <div>
      <MainContainer pageName="Stock" info={[]} breadcrumbs={["Stock"]}>
        <div className="flex w-full flex-col">

          <div className="flex  flex-wrap items-center gap-2  mb-2">
            <div className={`flex  items-center gap-2  ${isMobile ? 'w-full' : 'lg:w-3/5 sm:w-full'}`}>
             <Autocomplete
                size="sm"
                label="Group"
                className="max-w-40"
                placeholder={"--Select--"}
                defaultItems={
                  masterData && masterData.itemGroup
                    ? masterData.itemGroup
                    : []
                }
                isVirtualized
                selectedKey={selectedGroup}
                onSelectionChange={setSelectedGroup}
              >
                {(item) => (
                  <AutocompleteItem key={item.ITGR_CODE}>
                    {item.ITGR_NAME}
                  </AutocompleteItem>
                )}
              </Autocomplete>
               <Autocomplete
                size="sm"
                label="Category"
                className="max-w-36"
                placeholder={"--Select--"}
                defaultItems={masterData && masterData.itemCategory
                  ? masterData.itemCategory
                  : []}
                isVirtualized
                selectedKey={selectedCategory}
                onSelectionChange={setSelectedCategory}
              >
                {(item) => (
                  <AutocompleteItem key={item.CAT}>
                    {item.CAT}
                  </AutocompleteItem>
                )}
              </Autocomplete>
              <Autocomplete
                size="sm"
                name={"item"}
                label={"Product Name"}
                eventResizeFeature={true}
                selectionMode="single"
                showScrollIndicators={true}
                placeholder={"--Select--"}
                // className="w-full"
                classNames={{
                  label: "text-xs text-black font-bold",
                }}
                isClearable={true}
                variant="bordered"
                isVirtualized
                defaultItems={
                  itemMasterData
                    ? itemMasterData : []
                }
                onSelectionChange={setSelectedItem}
                selectedKey={selectedItem}
              >
                {(list) => (
                  <AutocompleteItem

                    key={list.Item_Code}
                  >
                    {list.Item_Desc}
                  </AutocompleteItem>
                )}
              </Autocomplete>
             


             

            </div>
            <div className={`flex  items-center gap-2 `}>
              <Button
                color="primary"
                startContent={<FontAwesomeIcon icon={faMagnifyingGlass} />}
                onPress={handleFilter}
              // isLoading={isPending}
              >
                Search
              </Button>
              <Button
                style={{ marginLeft: "5px" }}
                color="primary"
                startContent={<FontAwesomeIcon icon={faFilter} />}
                onPress={handleResetFilter}
              >
                Reset
              </Button>
            </div>
          </div>

        </div>
        <NextUITable
          INITIAL_VISIBLE_COLUMNS={INITIAL_VISIBLE_COLUMNS}
          data={data}
          handleDataChange={handleDataChange}
          columns={columns}
          exportColumns={exportColumns}
          downloadDataFooter={downloadDataFooter}
          showAdvanceFilter={false}
          downloadFileName="Stock"
          id="uniq_id"
        />
      </MainContainer>
    </div>
  )
}

export default Stock
